import { useQuery } from "react-query";
import { getHierarchyEmployeeOpts } from "actions/CarrierAgreementMgmt/Hierarchy";

export const useGetHierarchyEmployeeOpts = () => {
  return useQuery("GetHierarchyEmployeeOpts", getHierarchyEmployeeOpts, {
    refetchOnWindowFocus: false,
    enabled: true,
  });
};
